import { render, staticRenderFns } from "./SiteNav2.vue?vue&type=template&id=2ec4e184&"
import script from "./SiteNav2.vue?vue&type=script&lang=js&"
export * from "./SiteNav2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports